import React from 'react';
import { createPortal } from 'react-dom';
import {
    EditorState,
    Modifier,
    RichUtils,
    SelectionState,
} from 'draft-js';
import $ from 'jquery';

import LinkSuggestions from './LinkSuggestions';
import { isInternalLink, hasUrlScheme, findLink } from '../utilities/linkUtilities';
import { getSelectedLink } from '../utilities/selectionUtilities';
import { KEYCODE, ENTITY_TYPE, MUTABLE } from '../utilities/CONSTANTS';

const defaultState = {
    link: '',
    showSuggestions: true,
};

class LinkDialog extends React.Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = getSelectedLink(props.editorState) || defaultState;
    }

    componentDidMount() {
        document.body.addEventListener('click', this.clickHandler);
        setTimeout(() => this.textInput.current.focus(), 1);
    }

    addKeyDownEventHandler = (childEventHandler) => {
        this.childHandleKeyDownEvent = childEventHandler;
    };

    onKeyDown = (e) => {
        const { showSuggestions } = this.state;

        if (showSuggestions && this.childHandleKeyDownEvent && this.childHandleKeyDownEvent(e)) {
            return;
        }

        if (e.which === KEYCODE.enter) {
            e.preventDefault();
            this.createLink();
        } else if (e.which === KEYCODE.escape) {
            this.closeDialog();
        }
    };

    clickHandler = (e) => {
        const $target = $(e.target);
        if (!$target.is('.link-dialog') && !$target.parents().is('.link-dialog')) {
            e.preventDefault();
            this.closeDialog();
        }
    };

    closeDialog = () => {
        const { toggleLinkDialog } = this.props;

        document.body.removeEventListener('click', this.clickHandler);
        this.setState(defaultState);
        toggleLinkDialog(false);
    };

    createLink = (link) => {
        const { setEditorState } = this.props;
        const { text, link: stateLink } = this.state;
        let { editorState } = this.props;
        const contentState = editorState.getCurrentContent();
        const selectionState = editorState.getSelection();

        let url = link || stateLink;
        const isWellFormedUrl = isInternalLink(url) || hasUrlScheme(url);
        url = (isWellFormedUrl || url.includes('mailto:')) ? url : `http://${url}`;

        const contentStateWithEntity = contentState.createEntity(ENTITY_TYPE.LINK, MUTABLE, { url });
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

        if (selectionState.isCollapsed()) {
            editorState = EditorState.push(editorState, Modifier.insertText(contentState, selectionState, text, undefined, entityKey));
        } else {
            editorState = RichUtils.toggleLink(editorState, selectionState, entityKey);
        }

        const newSelectionState = SelectionState.createEmpty(selectionState.getEndKey())
            .merge({
                focusKey: selectionState.getEndKey(),
                focusOffset: selectionState.getEndOffset(),
                anchorOffset: selectionState.getEndOffset(),
                hasFocus: true,
            });
        editorState = EditorState.acceptSelection(editorState, newSelectionState);

        setEditorState(editorState);
        this.setState(defaultState);
        this.closeDialog();
    };

    onLinkChange = (event) => {
        const link = event.target.value;
        const showSuggestions = !(hasUrlScheme(link) || findLink.match(link));
        this.setState({ link, showSuggestions });
    };

    removeLink = () => {
        const { setEditorState } = this.props;
        let { editorState } = this.props;
        const selectionState = editorState.getSelection();

        if (!selectionState.isCollapsed()) {
            editorState = RichUtils.toggleLink(editorState, selectionState, null);
        }

        setEditorState(editorState);
        this.setState(defaultState);
        this.closeDialog();
    };

    removeKeyDownEventHandler() {
        this.childHandleKeyDownEvent = null;
    }

    render() {
        const { showSuggestions, link } = this.state;
        const position = Object.assign({}, this.props.position);
        const width = 275;
        position.top += 65;

        if (position.left < (width / 2)) {
            position.left = Math.ceil(width / 2);
        } else if ((position.left + (width / 2)) > window.innerWidth) {
            position.left = window.innerWidth - Math.ceil(width / 2);
        }

        const suggestionStyle = Object.assign({}, position);
        suggestionStyle.top = position.top + 45;
        suggestionStyle.position = 'absolute';
        suggestionStyle.width = width;

        const caretPosition = {
            ...position,
            top: position.top + 5,
            left: this.props.position.left,
        };

        return createPortal(
            <div>
                <div className="link-dialog-caret" style={caretPosition} />
                <div className="link-dialog z5" style={position}>
                    <input
                        ref={this.textInput}
                        className="link-edit-display"
                        type="text"
                        placeholder="Paste URL or type to search"
                        value={link}
                        onChange={this.onLinkChange}
                        onKeyDown={this.onKeyDown}
                    />
                    <button
                        className="link-edit-button"
                        onMouseDown={this.removeLink}
                    >
                        &times;
                    </button>
                </div>
                {
                    showSuggestions && (
                        <div style={suggestionStyle} className="z5">
                            <LinkSuggestions
                                searchText={link}
                                selectSuggestion={this.createLink}
                                addKeyDownEventHandler={this.addKeyDownEventHandler}
                                removeKeyDownEventHandler={this.removeKeyDownEventHandler}
                            />
                        </div>
                    )
                }
            </div>,
            document.body,
        );
    }
}

export default LinkDialog;
